/* tslint:disable */
/* eslint-disable */
/**
 * Ameta Delivery API
 * This API manages the projects and docuements that are stored in the Ameta Document Delivery. The API used oAuth2 flow for authorization.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GeoJSONLocation,
    GeoJSONLocationFromJSON,
    GeoJSONLocationFromJSONTyped,
    GeoJSONLocationToJSON,
} from './';

/**
 * 
 * @export
 * @interface Project
 */
export interface Project {
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    projectName: string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    projectNumber: string;
    /**
     * 
     * @type {GeoJSONLocation}
     * @memberof Project
     */
    projectLocation?: GeoJSONLocation;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    projectDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    endDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    customerProjectNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    projectOwnerName?: string;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    projectOwnerId?: string;
}

export function ProjectFromJSON(json: any): Project {
    return ProjectFromJSONTyped(json, false);
}

export function ProjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): Project {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'projectName': json['projectName'],
        'projectNumber': json['projectNumber'],
        'projectLocation': !exists(json, 'projectLocation') ? undefined : GeoJSONLocationFromJSON(json['projectLocation']),
        'projectDescription': !exists(json, 'projectDescription') ? undefined : json['projectDescription'],
        'startDate': !exists(json, 'startDate') ? undefined : json['startDate'],
        'endDate': !exists(json, 'endDate') ? undefined : json['endDate'],
        'customerProjectNumber': !exists(json, 'customerProjectNumber') ? undefined : json['customerProjectNumber'],
        'projectOwnerName': !exists(json, 'projectOwnerName') ? undefined : json['projectOwnerName'],
        'projectOwnerId': !exists(json, 'projectOwnerId') ? undefined : json['projectOwnerId'],
    };
}

export function ProjectToJSON(value?: Project | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'projectName': value.projectName,
        'projectNumber': value.projectNumber,
        'projectLocation': GeoJSONLocationToJSON(value.projectLocation),
        'projectDescription': value.projectDescription,
        'startDate': value.startDate,
        'endDate': value.endDate,
        'customerProjectNumber': value.customerProjectNumber,
        'projectOwnerName': value.projectOwnerName,
        'projectOwnerId': value.projectOwnerId,
    };
}


